import React, { useState, useEffect } from 'react';
import './imageslider.css';
import image1 from '../../assets/img/login.png';
import image2 from '../../assets/img/signup.png';
import image3 from '../../assets/img/application1.png';
import image4 from '../../assets/img/application_2.png';
import image5 from '../../assets/img/application_3.png';
import image6 from '../../assets/img/application_4.png';
import image7 from '../../assets/img/application_5.png';
import image8 from '../../assets/img/application_6.png';
import image9 from '../../assets/img/application_7.png';
import image10 from '../../assets/img/application_8.png';
import image11 from '../../assets/img/application_9.png';



const images = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11
];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Clean up on component unmount
  }, [currentIndex]);

  const goToPrevious = () => {
    const isFirstSlide = currentIndex === 0;
    setCurrentIndex(isFirstSlide ? images.length - 1 : currentIndex - 1);
  };

  const goToNext = () => {
    const isLastSlide = currentIndex === images.length - 1;
    setCurrentIndex(isLastSlide ? 0 : currentIndex + 1);
  };

  return (
    <div className="slider">
      <button className="left-arrow" onClick={goToPrevious}>
        ❮
      </button>
      <div
        className="slider-image"
        style={{ backgroundImage: `url(${images[currentIndex]})` }}
      ></div>
      <button className="right-arrow" onClick={goToNext}>
        ❯
      </button>
    </div>
  );
};

export default ImageSlider;
